// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cceuzwhghuyzldjxfvue.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjZXV6d2hnaHV5emxkanhmdnVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk2NTM0MzUsImV4cCI6MjA3NTIyOTQzNX0.BFzNP15P6M72o-uwqw3V8Ia76qWNZciO3g0VGg8oByk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});